// MonthViewHeader.jsx

import React from 'react';

// Utilities
import { dayNamesShort } from 'utilities/DateTime';

// CSS
import './MonthViewHeader.css';

/**
 * MonthViewHeader
 * 
 * Renders the header for the month view, displaying the short names of the days of the week.
 * 
 * @returns {ReactNode} - MonthViewHeader.
 */
const MonthViewHeader = () => {

  // ----- RENDER ----- //

  return (
    <div
      className="month-view-header-container"
    >
      {dayNamesShort.map((label) => (
        <div
          className="month-view-header-cell"
          key={label}
        >
          {label}
        </div>
      ))}
    </div>
  );
};

// Dev Tools
MonthViewHeader.displayName = 'MonthViewHeader';

export default MonthViewHeader;
